import { Stack, Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";

type Props = {
	index: number;
	icon: LucideIcon;
	label: string;
	description: string;
};

export const DocumentEmptyStateStep: FC<Props> = ({
	index,
	icon: Icon,
	label,
	description,
}) => {
	const theme = useTheme();

	return (
		<Stack direction="row" alignItems="center" gap={1.75} px={2} py={1.75}>
			<Stack
				alignItems="center"
				justifyContent="center"
				width={36}
				height={36}
				borderRadius="12px"
				flexShrink={0}
				bgcolor={theme.palette.blue[100]}
			>
				<Typography variant="bodyStrong" color={theme.palette.blue[500]}>
					{index + 1}
				</Typography>
			</Stack>
			<Stack flex={1} minWidth={0}>
				<Typography variant="bodyMedium">{label}</Typography>
				<Typography variant="caption" color={theme.palette.grey[500]}>
					{description}
				</Typography>
			</Stack>
			<Icon size={18} color={theme.palette.grey[300]} />
		</Stack>
	);
};
